import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_unpadded1ygmnwh0rw79t as get_unpadded,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  IconView$_get_description_$ref_x7iif61khv8gb32hpy6 as IconView$_get_description_$ref_x7iif6,
  IconView$_set_description_$ref_rpvc1e1z9j41dqp1rw7 as IconView$_set_description_$ref_rpvc1e,
} from '../../App.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  split2bvyvnrlcifjv as split,
  isBlank1dvkhjjvox3p0 as isBlank,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  And1a3dbpwh0hxmu as And,
  Always_getInstance177eud73uc475 as Always_getInstance,
  Or37bzl6q9twftg as Or,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  nullElement39ujy5fzowmto as nullElement,
  listElement3jy3tr2z6og1q as listElement,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import {
  DataClassPathNotNull3k4t7brymixty as DataClassPathNotNull,
  DataClassPath2zx7tvblx35e3 as DataClassPath,
  DataClassPathList1wm0kncx8ym4m as DataClassPathList,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  get_serializableProperties1162nosnaangd as get_serializableProperties,
  SerializableProperty3cbm268cpjr8q as SerializableProperty,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializableProperty.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  xDataClassPathContainsRawCased39irduoqizpcd as xDataClassPathContainsRawCased,
  xDataClassPathContainsCased3loynnz3n7tb9 as xDataClassPathContainsCased,
  path1xmlqjtovoe0v as path,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Companion_getInstance18mvmiinmr4hw as Companion_getInstance_0 } from '../../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function searchField(_this__u8e3s4, query) {
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var this_0 = sizeConstraints(get_centered(_this__u8e3s4), VOID, VOID, VOID, VOID, VOID, get_rem(15));
  var tmp$ret$0 = themed(this_0, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  var this_1 = get_unpadded(tmp$ret$0);
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element);
  this_1.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  element.set_gap_jwjroq_k$(get_px(0));
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  var this_2 = get_centered(element);
  // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
  var this_3 = themed(this_2, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (IconView())(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  this_3.willAddChild_hz2iwc_k$(element_0);
  element_0.set_source_3o5lkf_k$(Companion_getInstance().search_1.resize_q1xpz0_k$(get_rem_0(1.25)));
  var tmp = KMutableProperty0();
  var tmp_0 = IconView$_get_description_$ref_x7iif6(element_0);
  var tmp_1 = getPropertyCallableRef('description', 0, tmp, tmp_0, IconView$_set_description_$ref_rpvc1e(element_0));
  element_0.invoke_bnq13k_k$(tmp_1, searchField$lambda);
  element_0.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.expanding' call
  // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
  var this_4 = weight(element, 1.0);
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_5 = themed(this_4, ForcePaddingSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = new (TextInput())(this_5.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  this_5.willAddChild_hz2iwc_k$(element_1);
  element_1.bind_gesskf_k$(element_1.content_1, query);
  element_1.onStartup_vrxh3i_k$();
  this_5.addChild_2qpft2_k$(element_1);
  element.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element);
  return element;
}
function textSearchCondition(query, matchesWord) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = split(query, [' ']);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(element)) {
      destination.add_utx5q5_k$(element);
    }
  }
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!destination.isEmpty_y1axqb_k$()) {
    tmp = destination;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(tmp0_safe_receiver, 10));
    var _iterator__ex2g4s_0 = tmp0_safe_receiver.iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s_0.next_20eer_k$();
      destination_0.add_utx5q5_k$(matchesWord(item));
    }
    tmp_0 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(destination_0);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp1_elvis_lhs == null ? Always_getInstance() : tmp1_elvis_lhs;
}
function textSearchBuilders(fieldSerializer, path, depth) {
  depth = depth === VOID ? 0 : depth;
  if (depth > 8) {
    // Inline function 'kotlin.collections.listOf' call
    return emptyList();
  }
  var serialName = fieldSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
  var tmp;
  if (serialName === 'kotlin.String') {
    tmp = listOf((word) => xDataClassPathContainsCased(path instanceof DataClassPath() ? path : THROW_CCE(), word, true));
  } else if (Companion_getInstance_0().serialNames_1.contains_aljjnj_k$(serialName)) {
    tmp = listOf((word) => xDataClassPathContainsRawCased(path instanceof DataClassPath() ? path : THROW_CCE(), word, true));
  } else {
    var tmp0_safe_receiver = nullElement(fieldSerializer);
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp_1 = new (DataClassPathNotNull())(path);
      tmp_0 = textSearchBuilders(tmp0_safe_receiver, tmp_1 instanceof DataClassPath() ? tmp_1 : THROW_CCE(), depth + 1 | 0);
    }
    var tmp1_elvis_lhs = tmp_0;
    var tmp_2;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = listElement(fieldSerializer);
      var tmp_3;
      if (tmp2_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_3 = textSearchBuilders(tmp2_safe_receiver, new (DataClassPathList())(path instanceof DataClassPath() ? path : THROW_CCE()), depth + 1 | 0);
      }
      tmp_2 = tmp_3;
    } else {
      tmp_2 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_2;
    var tmp_4;
    if (tmp3_elvis_lhs == null) {
      var tmp4_safe_receiver = get_serializableProperties(fieldSerializer);
      var tmp_5;
      if (tmp4_safe_receiver == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var inductionVariable = 0;
        var last = tmp4_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp4_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp_6 = element.get_serializer_u29zhh_k$();
          var list = textSearchBuilders(tmp_6, path.prop(isInterface(element, SerializableProperty()) ? element : THROW_CCE()), depth + 1 | 0);
          addAll(destination, list);
        }
        tmp_5 = destination;
      }
      tmp_4 = tmp_5;
    } else {
      tmp_4 = tmp3_elvis_lhs;
    }
    var tmp5_elvis_lhs = tmp_4;
    var tmp_7;
    if (tmp5_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_7 = emptyList();
    } else {
      tmp_7 = tmp5_elvis_lhs;
    }
    tmp = tmp_7;
  }
  return tmp;
}
function allTextFieldsContain(_this__u8e3s4, word) {
  var tmp = path(_this__u8e3s4);
  // Inline function 'kotlin.collections.map' call
  var this_0 = textSearchBuilders(_this__u8e3s4, tmp instanceof DataClassPath() ? tmp : THROW_CCE());
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$2 = item(word);
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  return Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(destination);
}
function searchField$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_searchIconDescription_c0d0b6_k$();
}
//region block: exports
export {
  allTextFieldsContain as allTextFieldsContain2y4ctgpgxc740,
  searchField as searchField2rc6mst1no9ok,
  textSearchCondition as textSearchConditionr2nfggw95qef,
};
//endregion

//# sourceMappingURL=search.mjs.map
